import React from 'react';

export const TvIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <title>Televisie</title>
    <path d="M13,2H0V9a3,3,0,0,0,3,3H16V5A3,3,0,0,0,13,2Zm1,8H3A1,1,0,0,1,2,9V4H13a1,1,0,0,1,1,1Z" />
    <path d="M6,13h4a2,2,0,0,1,2,2v0a0,0,0,0,1,0,0H4a0,0,0,0,1,0,0v0A2,2,0,0,1,6,13Z" />
  </svg>
);
